import {
  SET_FORM_DATA,
} from "../types";

export const formActions = (props) => {
  return {
    setFormData: (data) => {
      props.dispatch({ type: SET_FORM_DATA, data })
    },
  }
}